
function logoutSession() {
    window.location = "/"
    localStorage.clear();
    localStorage.removeItem('Role');
    localStorage.removeItem('bearer_token');
    localStorage.removeItem('Page')
};
export default logoutSession